<template>
  <div id="GuestSearch_main">
    <FilterFrame
      ref="filter"
      :filter-form="guestSearchFilter"
      @search="handleSearch"
      @clear="clearSearch()"
    />
  </div>
</template>

<script>
import FilterFrame from '@/components/FilterFrame'

export default {
  components: {
    FilterFrame
  },
  props: {
    guestCauseList: {
      type: Array,
      default: () => []
    },
    isClearEmpty: {
      type: Boolean,
      default: false
    },
    reSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      guestSearchFilter: [
        {
          label: '訪客事由',
          name: 'causeTypeId',
          type: 'select',
          options: { id: '', value: '', label: '請選擇' },
          value: ''
        },
        {
          label: '拜訪戶別',
          name: 'household',
          type: 'house',
          value: '',
          alignCenter: true
        },
        {
          label: '訪客/廠商名稱',
          name: 'guestName',
          type: 'input',
          value: '',
          placeholder: '請輸入',
          clearable: true,
          maxlength: 20
        },
        {
          label: '預約狀態',
          name: 'reserveStatus',
          type: 'select',
          options: [
            { id: '', value: '', label: '請選擇' },
            { id: 2, value: 2, label: '已預約' },
            { id: 5, value: 5, label: '已取消' }
          ],
          value: ''
        }
      ],
      searchData: {}
    }
  },
  watch: {
    reSearch (val) {
      if (val) {
        this.handleSearch(this.searchData)
      }
    },
    guestCauseList () {
      const list = this.guestCauseList.map((item) => {
        return {
          value: item.Id,
          label: item.Name
        }
      })
      const newList = [
        { id: '', value: '', label: '請選擇' },
        ...list
      ]

      this.guestSearchFilter[0].options = newList
    }
  },
  methods: {
    handleSearch (selectValue) {
      const {
        causeTypeId = 0,
        guestName = '',
        household = {},
        reserveStatus = 0
      } = selectValue

      const newTabletId = household?.TabletId || ''

      const searchData = {
        CauseTypeId: causeTypeId,
        GuestName: guestName,
        TabletId: isNaN(newTabletId) ? '' : Number.parseInt(newTabletId, 10),
        GuestStatus: reserveStatus
      }

      // 訪客名稱需大於兩個字
      if (guestName && guestName.length < 2) {
        this.$message({
          message: '訪客/廠商名稱請輸入最少2個字進行查詢',
          type: 'warning'
        })
      } else {
        this.searchData = selectValue // 紀錄合法的查詢
        const newSearchData = this.isClearEmpty ? this.clearEmptyData(searchData) : searchData

        this.$emit('onSearch', newSearchData)
      }
    },
    clearEmptyData (searchData = {}) {
      const queryResult = {}

      Object.keys(searchData).forEach((key) => {
        // 移出null、0、空字串
        if (searchData[key]) {
          queryResult[key] = searchData[key]
        }
      })

      return queryResult
    },
    clearSearch () {
      this.guestSearchFilter[0].value = ''
      this.guestSearchFilter[1].value = ''
      this.guestSearchFilter[2].value = ''
      this.guestSearchFilter[3].value = ''

      this.searchData = {}
      this.$emit('onSearch', {})
    }
  }
}
</script>
<style lang="sass" scoped>
#GuestSearch_main

::v-deep .el-form-item
  text-align: center !important
::v-deep .el-form-item label[for=guestName]
  width: auto !important
</style>
